import {
  Component,
  ViewEncapsulation,
  Input,
  ViewChild,
  TemplateRef,
  Output,
  Attribute,
  EventEmitter,
} from '@angular/core';
import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';

import { PblNgridComponent } from '@pebula/ngrid';
import { getExcelExportPlugin } from '../../sg-table-extension.module';

@Component({
  selector: 'sg-ngrid-action-row',
  templateUrl: './table-action-row.component.html',
  styleUrls: ['./table-action-row.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class SgTableActionRowComponent {
  /**
   * Show/Hide a filter box
   * The filter box will automatically filter the datasource using a local filter unless
   * there are active connected subscribers (observers) to `onFilter`
   */
  @Input() get filter(): BooleanInput {
    return this._filter;
  }
  set filter(value: BooleanInput) {
    this._filter = coerceBooleanProperty(value);
  }

  @Input() get exportExcel(): BooleanInput {
    return this._exportExcel;
  }
  set exportExcel(value: BooleanInput) {
    this._exportExcel = coerceBooleanProperty(value);
  }

  @Input() label: string;

  @Input() filterLabel: string = 'Filter';

  @Input() filterWidth: string = '232px';

  @Input() type: 'simple' | 'withLabel' = 'simple';

  @ViewChild('actionRow', { read: TemplateRef, static: true }) actionRow: TemplateRef<any>;
  @ViewChild('actionRowLabel', { read: TemplateRef, static: true }) actionRowLabel: TemplateRef<any>;

  @Input() get disableSpacer(): BooleanInput {
    return this._disableSpacer;
  }
  set disableSpacer(value: BooleanInput) {
    this._disableSpacer = coerceBooleanProperty(value);
  }

  /** The gap between items in the header. pass 'disabled' to remove it. The default is 8px. */
  @Input() get headerGap(): string {
    return this._headerGap;
  }
  set headerGap(value: string) {
    this._headerGap = value === 'disabled' ? '' : value;
  }

  /**
   * Emits when the filter changes.
   */
  @Output() onFilter = new EventEmitter<string>();

  private _disableSpacer = false;
  private _filter = false;
  private _exportExcel = false;
  private _headerGap = '8px';
  public exporter = getExcelExportPlugin(this.table);

  constructor(
    public table: PblNgridComponent<any>,
    @Attribute('class') public cls: string
  ) {}

  ngAfterViewInit(): void {
    this.table.createView('beforeTable', this.type === 'withLabel' ? this.actionRowLabel : this.actionRow);
  }

  actionRowExport(): void {
    this.exporter.export();
  }

  actionRowFilter(filterValue: string) {
    if (this.onFilter.observers.length > 0) {
      this.onFilter.next(filterValue.trim());
    } else {
      this.table.ds.setFilter(filterValue.trim(), this.table.columnApi.visibleColumns);
    }
  }
}
